<template>
<div>
  <h4> {{$t('leads.details.follow_up')}}</h4>
  <template :headerText="$t('leads.details.follow_up')">
    <div v-if="pursues.length">
      <div v-for="pursue in pursues" :key="pursue.id" class="cards">
        <div class="card-body">
          <h6 class="card-title"><b>{{pursue.created_at | localTime}}<span v-if="pursue.user"> {{'leads.details.by' | translate }} {{pursue.user.name}}</span></b>
            <a v-if="pursue.user && writePermission && pursue.status !== 15 " href="#" @click.prevent="deletePursue(pursue)"><i class="fa fa-trash is-danger" aria-hidden="true"></i></a>
          </h6>
          <p class="card-text">

            {{ $t(getStatusByProperty('id', pursue.status)) }}

            <span v-if="pursue.sale_price || pursue.sale_at">
              &nbsp;({{presentSale(pursue)}})</span>
          </p>
          <p class="card-text observations" v-if="pursue.obs && pursue.obs.length > 0">{{pursue.obs}}</p>
        </div>
      </div>
    </div>
    <div v-else>
      {{$t('leads.details.no_regists')}}
      <br>
      <br>
    </div>
    <div v-if="writePermission" class="cards">
      <div class="card-body evollu-form">
        <h6 class="card-title is-uppercase">{{$t('leads.details.update_status')}}</h6>
        <div class="row no-gutters">
          <div class="col-12 col-md-8 col-lg-6">
            <!-- <div :class="{'col-md-12': editingStatus.id != 110, 'col-md-8': editingStatus.id == 110}"> -->
            <multiselect
              v-model="editingStatus"
              :options="statuses"
              track-by="id"
              label="name"
              :custom-label="status => $t(status.name)"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              >
            </multiselect>
          </div>
        </div>
        <div class="row no-gutters" v-if="editingStatus.id == 110 && priceWritePermission">
          <div class="col-12 col-sm-4 pr-2">
            <va-input
            :label="$t('leads.details.sale_price')"
            placeholder="€"
            type="text" v-model="editingSalePrice" @keypress=onlyForCurrency id="price"/>
          </div>

          <div class="col-12 col-sm-2 pr-2">
            <label class="form-label">{{$t('leads.details.vat')}}</label>
            <multiselect
              v-model="selectedVat"
              :options="vatOptions"
              track-by="id"
              label="vat"
              :custom-label="opt => `${opt.vat}%`"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              :allow-empty="false"
              :multiple="false"
              :searchable="false"
            />
          </div>

          <div class="col-12 col-sm-6">
            <!-- TODO: -->
            <va-date-picker
              :label="$t('leads.details.sale_date')"
              id="date-picker"
              :config="saleDatePickerConfig"
              v-model="editingSaleDate"
              placeholder="---"
            />
          </div>
        </div>
        <div class="card-text">
          <label class="form-label">{{$t('leads.details.observations')}}</label>
          <va-input type="textarea" rows="3" :placeholder="$t('leads.details.placeholder_obs')" v-model="editingObs"></va-input>
        </div>
        <br>
        <div class="card-text" style="position: relative; min-height: 65px">
          <va-button class="pull-right" :disabled="isLoadingFromServer" @click.prevent="addRecord">{{$t('leads.details.add') }}</va-button>
        </div>
      </div>
    </div>
  </template>

    <va-modal
      size="small"
      v-model="showDeleteConfirmation"
      ref="deleteConfirmationModal"
      title=""
      :cancelText="'modal.cancel' | translate"
      :okText="'modal.confirm' | translate"
      @ok="confirmDelete">
      <div slot="header"><p style="font-size: 18px;"><b>{{'leads.modal.delete?' | translate }}</b></p></div>
      <div v-if="pursueToDelete">
        {{ $t('leads.modal.description') }} {{pursueToDelete.created_at | localTime}}? {{ $t('leads.modal.description_2') }}
      </div>
    </va-modal>
</div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import DatePicker from '@/components/common/DatePicker'
import { mapGetters } from 'vuex'
import { Portuguese as PTLocale } from 'flatpickr/dist/l10n/pt'
import { Spanish as ESLocale } from 'flatpickr/dist/l10n/es'
PTLocale.firstDayOfWeek = 1
PTLocale.rangeSeparator = ' a '

const toastOptionsError = {
  className: 'vuestic-toast danger',
  icon: 'fa-exclamation-triangle',
  position: 'top-right',
  duration: 2500,
  fullWidth: false
}

const toastOptionsSuccess = {
  className: 'vuestic-toast',
  icon: 'fa-check',
  position: 'top-right',
  duration: 2500,
  fullWidth: false
}

export default {
  components: {
    Multiselect,
    DatePicker
  },
  props: [
    'pursues',
    'selectedLeadId',
    'selectedLeadEntityId',
    'salePriceEntitiesRead',
    'salePriceEntitiesWrite',
    'entitiesWrite',
    'leadStatus',
    'service',
  ],
  computed: {
    ...mapGetters({
      statuses: 'leads/statuses'
    }),
    currentLanguage: function () {
      return Vue.i18n.locale()
    },
    saleDatePickerConfig: function () {
      let config = { }

      if (this.currentLanguage === 'pt') {
        config.locale = PTLocale
      } else if (this.currentLanguage === 'es') {
        config.locale = ESLocale
      } else {
        config.locale = { firstDayOfWeek: 1 }
      }

      return config
    }
  },
  data () {
    return {
      vatOptions: [{id:1, vat:6}, {id:2, vat:13}, {id:3, vat:23}],
      selectedVat: null,
      editingStatus: this.leadStatus,
      editingObs: '',
      editingSalePrice: '',
      editingSaleDate: this.moment().format('YYYY-MM-DD'),
      priceReadPermission: false,
      priceWritePermission: false,
      writePermission: false,
      showDeleteConfirmation: false,
      pursueToDelete: null,
      isLoadingFromServer: false,
    }
  },
  methods: {
    getStatusByProperty: function (property, value) {
      let status = this.statuses.find(status => status[property] === value)
      return status ? status.name : null
    },
    presentSale: function (pursue) {
      let sale = []

      if (this.priceReadPermission && pursue.sale_price) {
        sale.push(`${this.$t('leads.details.price')}: € ${this.presentPrice(pursue.sale_price)}(${this.$t('leads.details.vat')}: ${pursue.vat}%)`)
      }

      if (pursue.sale_at) {
        let saleDate = this.$options.filters.localTime(pursue.sale_at, 'YYYY-MM-DD')
        sale.push(`${this.$t('leads.details.date')}: ${saleDate}`)
      }

      return sale.join(', ')
    },
    presentPrice: function (value) {
      return (value / 100).toFixed(2).replace('.', ',')
    },
    addRecord: function () {
      this.isLoadingFromServer = true
      let body = {
        obs: this.editingObs,
        status: this.editingStatus.id
      }

      if (this.editingStatus.id === 110 && this.editingSalePrice !== '') {
        body.sale_price = parseFloat(this.editingSalePrice.replace(',', '.')).toFixed(2) * 100
        body.sale_at = this.editingSaleDate
        body.vat = this.selectedVat.vat
      }

      let method = 'post'
      this.$http({
        method: method,
        url: this.service.url + '/pursues/' + this.selectedLeadId,
        data: body
      }).then((response) => {
        let user = response.data.updated_by
        let newPursue = {
          id: response.data.id,
          obs: response.data.lead.obs,
          created_at: response.data.lead.created_at,
          updated_at: response.data.lead.updated_at,
          status: response.data.lead.status,
          sale_price: response.data.lead.sale_price,
          sale_at: response.data.lead.sale_at,
          vat: response.data.lead.vat,
          user: user
        }
        let qualifiedAt = response.data.qualified_at
        this.$emit('createdPursue', { 'newPursue': newPursue, 'qualifiedAt': qualifiedAt })
        this.editingObs = ''
        this.editingSalePrice = ''
        this.showToast(this.$t('leads.messages.add'), toastOptionsSuccess)
      }).catch((error) => {
        console.log(error)
        this.showToast(this.$t('leads.messages.error'), toastOptionsError)
      }).finally(() => {
        setTimeout(() => {
          this.isLoadingFromServer = false
        }, 3000)
      })
    },
    deletePursue: function (pursue) {
      this.pursueToDelete = pursue
      this.showDeleteConfirmation = true
    },
    confirmDelete: function () {
      this.$http({
        method: 'DELETE',
        url: this.service.url + '/pursues/' + this.pursueToDelete.id
      }).then((response) => {
        this.showDeleteConfirmation = false
        this.$emit('deletedPursue', { 'pursueToDelete': this.pursueToDelete, 'leadStatus': response.data.data.status, 'qualifiedAt': response.data.data.qualified_at })
        this.pursueToDelete = null
        this.showToast(this.$t('leads.messages.remove'), toastOptionsSuccess)
      }).catch((error) => {
        console.log(error)
        this.showToast(this.$t('leads.messages.error'), toastOptionsError)
        this.showDeleteConfirmation = false
      })
    },
    onlyForCurrency ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)

      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 44 || this.editingSalePrice.indexOf(',') !== -1)) { // 46 is dot
        $event.preventDefault()
      }
      if (this.editingSalePrice === '' && (keyCode === 48 || keyCode === 44)) {
        $event.preventDefault()
      }
      if (this.editingSalePrice != null && this.editingSalePrice.indexOf(',') > -1 && (this.editingSalePrice.split(',')[1].length > 1)) {
        $event.preventDefault()
      }
    },
    hasPricePermission () {
      this.priceReadPermission = this.salePriceEntitiesRead.includes(this.selectedLeadEntityId)
      this.priceWritePermission = this.salePriceEntitiesWrite.includes(this.selectedLeadEntityId)
    },
    hasWritePermission () {
      this.writePermission = this.entitiesWrite.includes(this.selectedLeadEntityId)
    }
  },
  watch: {
    selectedLeadId: function (value) {
      this.editingStatus = this.statuses.find(data => data.id === parseInt(this.leadStatus))
      this.hasPricePermission()
      this.hasWritePermission()
    }
  },
  mounted () {
    this.editingStatus = this.statuses.find(data => data.id === parseInt(this.leadStatus))
    this.hasPricePermission()
    this.hasWritePermission()
    this.selectedVat = this.vatOptions[0]
  },
}
</script>

<style lang="scss">
  .sale-price {
    .input-icon {
      top: 0.55rem;
    }

    .form-group.with-icon-left input {
      padding-left: 1rem;
    }

  }

  // .datePicker label {
  //   position: absolute;
  //   font-size: 0.6rem;
  //   color: #29c4a9;
  //   font-weight: 600;
  //   text-transform: uppercase;
  //   top: -0.4rem;
  //   left: 0;
  // }

</style>
<style lang="scss" scoped>
.cards {
  margin-bottom: 1rem;
  // border: 0.5px solid #6e6e6e30;
  border: 1px solid rgba(0, 0, 0, 0.1)
}
</style>
